import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AddDataUploadedPayload, UploadedData } from '@cashier/cashier-model';

export const FILE_UPLOADING_FEATURE_KEY = 'fileUploading';

interface UploadFileSuccessPayload {
  name: string;
  link: string;
}

export interface FileUploadingState {
  data: UploadedData | null;
}

export const initialFileUploadingState: FileUploadingState = {
  data: null,
};

export const fileUploadingSlice = createSlice({
  name: FILE_UPLOADING_FEATURE_KEY,
  initialState: initialFileUploadingState,
  reducers: {
    addDataToUpload: (state, action: PayloadAction<AddDataUploadedPayload>) => {
      const { file, name } = action.payload;

      state.data = {
        file,
        name,
        link: null,
      };
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    uploadFileStart: (state) => {},
    uploadFileSuccess: (
      state,
      action: PayloadAction<UploadFileSuccessPayload>,
    ) => {
      const newData = state.data as UploadedData;
      newData.link = action.payload.link;

      state.data = newData;
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    uploadFileFailure: (state, action: PayloadAction<any>) => {},
  },
});

export const fileUploadingReducer = fileUploadingSlice.reducer;

export const {
  addDataToUpload,
  uploadFileStart,
  uploadFileSuccess,
  uploadFileFailure,
} = fileUploadingSlice.actions;
